import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import '../styles/FeaturedWatches.css';
import { getAllWatchesWithInstagram } from '../utils/watchData';
import { withCropParams } from '../utils/imageUrl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { useTranslation } from 'react-i18next';

const FeaturedWatches = () => {
  const [watches, setWatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    // Fetch watches from Firebase
    const fetchWatches = async () => {
      setLoading(true);
      try {
        console.log("Fetching watches for featured section...");
        const allWatches = await getAllWatchesWithInstagram();
        console.log("Watches fetched:", allWatches.length, "items");
        setWatches(allWatches);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching watches:', err);
        setError('Failed to load watches');
        setLoading(false);
      }
    };

    fetchWatches();

    // No need for regular polling in this component - it increases load
  }, []);

  if (loading) {
    return (
      <div className="section featured-watches">
        <div className="container">
          <div className="loading-container">
            <div className="loading-spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="section featured-watches">
        <div className="container">
          <div className="error-message">
            {error}
          </div>
        </div>
      </div>
    );
  }

  // Show a message if no watches are available
  if (!watches || watches.length === 0) {
    return (
      <div className="section featured-watches">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="section-header"
          >
            <h2>{t('featured.title')}</h2>
            <p>{t('featured.emptyMessage')}</p>
          </motion.div>
        </div>
        
        {/* WhatsApp Button */}
        <a 
          href={`https://wa.me/905550236044`} 
          target="_blank" 
          rel="noopener noreferrer" 
          className="whatsapp-button"
          aria-label={t('whatsapp.aria_label')}
        >
          <FontAwesomeIcon icon={faWhatsapp} />
        </a>
      </div>
    );
  }

  return (
    <div className="section featured-watches">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="section-header"
        >
          <h2>{t('featured.title')}</h2>
          <p>{t('featured.subtitle')}</p>
        </motion.div>
        
        <div className="watches-grid">
          {watches.map((watch, index) => (
            <Link to={`/watches/${watch.id}`} key={watch.id} className="watch-card-link">
              <motion.div
                className="watch-card"
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: Math.min(0.04 * index, 1.2) }}
              >
                <div className="watch-image">
                  <img 
                    src={watch.images && watch.images[0] ? 
                      withCropParams(watch.images[0], 800) : 
                      'https://via.placeholder.com/800x800?text=No+Image'} 
                    alt={watch.name} 
                  />
                </div>
                <div className="watch-info">
                  <h3>{watch.name}</h3>
                  <p>{watch.description}</p>
                  <span className="watch-price">{watch.price}</span>
                </div>
              </motion.div>
            </Link>
          ))}
        </div>
      </div>
      
      {/* WhatsApp Button */}
      <a 
        href={`https://wa.me/905550236044`} 
        target="_blank" 
        rel="noopener noreferrer" 
        className="whatsapp-button"
        aria-label={t('whatsapp.aria_label')}
      >
        <FontAwesomeIcon icon={faWhatsapp} />
      </a>
    </div>
  );
};

export default FeaturedWatches; 